/**
 * TI-1111 — server-derived audio-transcription disclosure for the integrity consent modal.
 *
 * The observer that TRANSCRIBES candidate audio is gated server-side on the platform flag
 * `observer.lifelike.enabled` (bot-backend observer/server_gate.py polls UM
 * GET /api/config/observer-lifelike before ever observing a room). The consent DISCLOSURE
 * must read the same source, or the two drift — on prod 2026-07-23 the observer transcribed
 * audio while the recorded consent scope excluded "audio" (an under-claim we must never repeat).
 *
 * Fail-closed direction is deliberately the INVERSE of the server's: the endpoint fails closed
 * to enabled=false (never start the recorder), the disclosure fails closed to TRUE (when the
 * server state is unknowable from this browser, over-disclose rather than under-claim).
 */
import { OBSERVER_LIFELIKE_CONFIG_URL } from "./endpoints";

/** Hard cap so a slow UM can only delay the consent modal briefly, never block it. */
export const DISCLOSURE_FETCH_TIMEOUT_MS = 3000;

export async function fetchAudioTranscriptionDisclosure(url = OBSERVER_LIFELIKE_CONFIG_URL) {
  if (!url) {
    console.warn(
      "[integrity] REACT_APP_UM_API_URL unset — cannot read observer.lifelike.enabled; " +
        "disclosing audio transcription (fail-closed)."
    );
    return true;
  }
  try {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), DISCLOSURE_FETCH_TIMEOUT_MS);
    let res;
    try {
      res = await fetch(url, { signal: controller.signal });
    } finally {
      clearTimeout(timer);
    }
    if (!res.ok) return true;
    const body = await res.json();
    if (typeof body?.enabled === "boolean") return body.enabled;
    return true;
  } catch (e) {
    console.warn("[integrity] observer-lifelike fetch failed — disclosing audio (fail-closed):", e);
    return true;
  }
}
